import clsx from "clsx";
import { ServiceTimeKindType } from "@ancon/wildcat-types";
import { PropsWithChildren } from "react";

import styles from "./NavBarOrderTimeSwitchButton.module.scss";
import Button from "../support/Button";

type NavBarOrderTimeSwitchButtonProps = PropsWithChildren<{
  type: ServiceTimeKindType;
  isInNavBar: boolean;
  onClick?: (type: ServiceTimeKindType) => void;
  disabled?: boolean;
}>;

export default function NavBarOrderTimeSwitchButton({
  type,
  isInNavBar = false,
  children,
  onClick,
  disabled = false,
}: NavBarOrderTimeSwitchButtonProps) {
  const selectedServiceTimeKindType = ServiceTimeKindType.AsSoonAsPossible;

  function handleOnClick() {
    onClick?.(type);
  }

  return (
    <Button
      variant="secondary"
      className={clsx(styles.button, {
        [styles.inNavBar]: isInNavBar,
        [styles.selected]: selectedServiceTimeKindType === type,
        [styles.disabled]: disabled,
      })}
      onClick={handleOnClick}
      disabled={disabled}
    >
      <span className={styles.serviceTimeData}>{children}</span>
    </Button>
  );
}
